import React, { Component } from "react";
import TableModal from "../../UI/TableModal";
import {
  isSet,
  getSelectedValueBasedOnField,
  isObject,
  IsJsonString,
} from "../../../Utils/CommonFunctions";
import { getFieldPropertiesFromGridList } from "../../../Containers/LayoutContainer/LayoutCommonFunction";
import http from "../../../services/http";
import Wrp from "../../../hoc/Wrp/Wrp";
import PagesServices from "../../../services/PagesServices";
import {
  extractConfigAttributes,
  buildLookupExecutePayload,
  buildLookupSelection,
  getLookupRecordId,
  getLookupRowId,
  getLookupStoredValue,
} from "../../../Containers/PagesContainer/PagesContainerUtils";
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';

const PAGES_LOOKUP_CHECKBOX_TYPES = new Set(["checkbox", "checkboxes", "boolean"]);

const isPagesLookupCheckboxType = (fieldType) => {
  if (fieldType == null || fieldType === "") return false;
  const normalized = String(fieldType).trim().toLowerCase().replace(/[\s_-]+/g, "");
  return PAGES_LOOKUP_CHECKBOX_TYPES.has(normalized);
};

const isPagesLookupCheckboxToken = (value) => {
  if (typeof value === "boolean") return true;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "false";
  }
  return false;
};

class PagesLookupModal extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
        isModalOpen:this.props.isModalOpen,
        isQuickAddModalOpen:false,
        status:null,
        isConfirmPage:false,
        tableRecords:{
          tableHead:[],
          tableData:[], 
          pagination:{
            page:0,
            orderBy:'',
            perPage:10,
            direction:'ASC',
            totalRecords:0,
            search:''
          }
        },
        selectedValueCustom: this.props.selectedValue != null && typeof this.props.selectedValue === 'object' && 'value' in this.props.selectedValue
          ? this.props.selectedValue.value
          : this.props.selectedValue,
        // Pages API state
        pageConfig: null,
        inputVariables: [],
        outputVariables: [],
        pageConfigId: null,
        config: null,
    }
  }
  // componentWillMount = ()=>{
    // this.LayoutsFormsList(this.state.tableRecords.pagination);
  // } 
    componentDidUpdate = (prevProps) => {
      if(prevProps.isModalOpen !== this.props.isModalOpen) {
        this.setState({
          isModalOpen: this.props.isModalOpen,
          selectedValueCustom: this.props.isModalOpen ? this.getSelectedId(this.props.selectedValue) : this.state.selectedValueCustom
        });
        if(this.props.isModalOpen===true && this.state.isQuickAddModalOpen===false){
          // Initialize config if not already set
          if (!this.state.config && this.props.childrenProps) {
            const config = extractConfigAttributes(this.props.childrenProps);
            if (config) {
              this.setState({ config }, () => {
                if (config.apiAction && config.apiAction.trim() !== "") {
                  this.fetchPageConfigAndVariables(config.apiAction, () => {
                    this.LayoutsFormsList(this.state.tableRecords.pagination, true);
                  });
                } else {
                  this.LayoutsFormsList(this.state.tableRecords.pagination, true);
                }
              });
            } else {
              this.LayoutsFormsList(this.state.tableRecords.pagination, true);
            }
          } else {
            this.LayoutsFormsList(this.state.tableRecords.pagination, true);
          }
        }
      }
    }

    setState(updates, callback) {
      if (!this._isMounted) {
        return;
      }
      super.setState(updates, callback);
    }

    componentDidMount = () => {
      this._isMounted = true;
      // Initialize config from props
      if (this.props.childrenProps) {
        const config = extractConfigAttributes(this.props.childrenProps);
        if (config && config.apiAction && config.apiAction.trim() !== "") {
          this.setState({ config }, () => {
            this.fetchPageConfigAndVariables(config.apiAction);
          });
        }
      }
    }

    // Fetch page config and input/output variables once
    fetchPageConfigAndVariables = async (apiAction, callback) => {
      try {
        const pageConfigResponse = await PagesServices.getConfigByName(apiAction);
        
        if (pageConfigResponse && pageConfigResponse.code === 200 && pageConfigResponse.data) {
          const pageConfig = pageConfigResponse.data;
          const pageConfigId = pageConfig.id;
          const variablesResponse = await PagesServices.getConfigVariablesList(pageConfigId);
          
          if (variablesResponse && variablesResponse.code === 200 && variablesResponse.data) {
            const inputVariables = variablesResponse.data.content.filter(v => v.is_request === true);
            const outputVariables = variablesResponse.data.content.filter(v => v.is_response === true);
            
            this.setState({
              pageConfig,
              pageConfigId,
              inputVariables,
              outputVariables,
            }, () => {
              if (callback) callback();
            });
          }
        }
      } catch (error) {
        console.error('Error fetching page config and variables:', error);
        if (callback) callback();
      }
    }
    componentWillUnmount = () => {
      this._isMounted = false;
    }

    componentDidCatch(error, errorInfo) {
      console.log('componentDidCatch(error, errorInfo) ....');
    }
    
    onChangeSelectLookup = (rowId,wthis)=>{
      //console.log('onChangeSelectLookup')
      const tableDataSel = this.state.tableRecords;
      tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          tableDataSel.tableData.data[index].className='selected';
          tableDataSel.tableData.data[index].data.RadioButton.checked=true;
          let displayName = [];
          let defaultDisplay = [];
          tableDataSel.tableHead.forEach((columnData,columnIndex)=>{
            const colId = tableDataSel.tableHead[columnIndex].columnId;
            if(tableDataSel.tableData.data[index].data[colId]){
              const selectedItem = tableDataSel.tableData.data[index].data[colId];
              const selectedValue = selectedItem.value;
              if(selectedValue!=='' && selectedValue!==undefined && selectedValue!==null){
                displayName.push(selectedValue);
                if(selectedItem.isDefaultDisplay===true && defaultDisplay.length<2){
                  defaultDisplay.push(selectedValue);
                }
              }
            }
          })
          const endPos = (tableDataSel.tableHead.length<=2)? tableDataSel.tableHead.length:2;
          displayName = (defaultDisplay.length===0)?displayName.slice(0,endPos):defaultDisplay;
        }else{
          tableDataSel.tableData.data[index].className='';
          tableDataSel.tableData.data[index].data.RadioButton.checked=false;
        }
      })
      this.setState({tableRecords:{
        ...tableDataSel
      }, selectedValueCustom: rowId})
    }

  
  /**
   * Same label rules as Packages autocomplete (Lookup index.js):
   * defaultField → first resultField → recordIdField → first column value.
   * Do NOT join Name + Length (layout-style first-2-columns).
   */
  resolveDisplayLabelFromRecord = (record, selectedRow, tableHead) => {
    const config = this.state.config || {};
    const defaultField = config.defaultField || "";
    const recordIdField = config.recordIdField || "";
    const resultFields = Array.isArray(config.resultFields)
      ? config.resultFields
      : [];

    const readField = (obj, fieldPath) => {
      if (!obj || !fieldPath) return "";
      let raw;
      if (String(fieldPath).includes(".")) {
        raw = this.getNestedValue(obj, fieldPath);
      } else if (obj[fieldPath] != null && obj[fieldPath] !== "") {
        raw = obj[fieldPath];
      } else {
        const foundKey = Object.keys(obj).find(
          (k) => k.toLowerCase() === String(fieldPath).toLowerCase()
        );
        raw = foundKey != null ? obj[foundKey] : undefined;
      }
      if (raw == null || raw === "" || isObject(raw) === true) return "";
      return String(raw);
    };

    if (record) {
      if (defaultField) {
        const fromDefault = readField(record, defaultField);
        if (fromDefault) return fromDefault;
      }
      for (let i = 0; i < resultFields.length; i += 1) {
        const key = resultFields[i] && resultFields[i].key;
        const fromField = readField(record, key);
        if (fromField) return fromField;
      }
      if (recordIdField) {
        const fromId = readField(record, recordIdField);
        if (fromId) return fromId;
      }
    }

    // Fallback: only the column marked isDefaultDisplay (never join multiple)
    if (selectedRow && Array.isArray(tableHead)) {
      for (let i = 0; i < tableHead.length; i += 1) {
        const colId = tableHead[i] && tableHead[i].columnId;
        if (!colId || !selectedRow.data || !selectedRow.data[colId]) continue;
        const cell = selectedRow.data[colId];
        if (
          cell.isDefaultDisplay === true &&
          cell.value !== "" &&
          cell.value != null &&
          isObject(cell.value) !== true
        ) {
          return String(cell.value);
        }
      }
      for (let i = 0; i < tableHead.length; i += 1) {
        const colId = tableHead[i] && tableHead[i].columnId;
        if (!colId || !selectedRow.data || !selectedRow.data[colId]) continue;
        const cell = selectedRow.data[colId];
        if (
          cell.value !== "" &&
          cell.value != null &&
          isObject(cell.value) !== true
        ) {
          return String(cell.value);
        }
      }
    }
    return "";
  };

  //MODAL POPUP - CONFIRM
  confirmLoopupModalHandler = () => {
    const rowId = this.state.selectedValueCustom;
    const tableDataSel = this.state.tableRecords;
    const selectedRow = tableDataSel.tableData.data.find(item => item.rowId === rowId);
    
    if (selectedRow && this.props.setLookupValuesFromList) {
      const record =
        (this.lookupSource &&
          (this.lookupSource[rowId] ||
            this.lookupSource[selectedRow.metaRowId])) ||
        null;
      const config = this.state.config || {};
      const label = this.resolveDisplayLabelFromRecord(
        record,
        selectedRow,
        tableDataSel.tableHead
      );

      // Prefer same { id, label, value } shape as autocomplete buildLookupSelection
      let selectedPayload = null;
      if (record) {
        selectedPayload = buildLookupSelection(
          record,
          config.recordIdField,
          label
        );
      }
      if (!selectedPayload) {
        selectedPayload = {
          id: selectedRow.metaRowId || rowId,
          label,
          value: rowId,
        };
      }
      selectedPayload.fields = selectedRow.data;
      selectedPayload.ruleMapping = selectedRow.ruleMapping || {};
      if (this.props.includeRecord && record) {
        selectedPayload.lookupData = record;
      }
      this.props.setLookupValuesFromList(selectedPayload);
    }
    
    if (this.props.cancelLoopupModalHandler) {
      this.props.cancelLoopupModalHandler();
    }
  }

recordsChangeHandler = (pagination) => {
    this.LayoutsFormsList(pagination, true); // Show loader during API call
}
 
  LayoutsFormsList = async (pagination, loader = true) => {
    const { config, pageConfigId, inputVariables, pageConfig, outputVariables } = this.state;
    const { searchField, offset, limit, resultVar, recordIdField, resultFields, totalRecordVar } = config || {};
    
    console.log('LayoutsFormsList - config from state:', config);
    console.log('LayoutsFormsList - resultFields from config:', resultFields);
    console.log('LayoutsFormsList - resultFields length:', resultFields?.length);
    
    if (!config || !config.apiAction || config.apiAction.trim() === "") {
      console.warn('No API action configured');
      return;
    }

    // Show loader during API call
    if (loader === true) {
      this.props.Loader(true);
    }

    this.setState({
      tableRecords: {
        ...this.state.tableRecords,
        pagination: pagination
      }
    });

    const page = pagination.page || 0;
    const perPage = pagination.perPage || 10;
    const search = pagination.search || "";

    try {
      // Ensure we have page config and variables
      let currentPageConfigId = pageConfigId;
      let currentInputVariables = inputVariables;
      let currentPageConfig = pageConfig;
      
      if (!currentPageConfigId || !currentInputVariables || currentInputVariables.length === 0 || !currentPageConfig) {
        await this.fetchPageConfigAndVariables(config.apiAction);
        currentPageConfigId = this.state.pageConfigId;
        currentInputVariables = this.state.inputVariables;
        currentPageConfig = this.state.pageConfig;
      }

      if (!currentPageConfigId || !currentInputVariables || currentInputVariables.length === 0 || !currentPageConfig) {
        console.error('Failed to get page config or variables');
        if (loader === true) {
          this.props.Loader(false);
        }
        return;
      }

      // Get from_page_mapping from config (similar to PagesRenderComponent pattern)
      const fromMapping = currentPageConfig.from_page_mapping || [];
      
      // Create inputMap similar to PagesRenderComponent
      const inputMap = Object.fromEntries(
        currentInputVariables.map(item => [item.id, item.api_name])
      );

      const payload = buildLookupExecutePayload({
        fromMapping,
        inputMap,
        config,
        fieldFormPayload: this.props.fieldFormPayload,
        search,
        page,
        perPage,
      });

      const API_URL = `pageconfig/${currentPageConfigId}/pages-config-execute`;
      const response = await http.POST(API_URL, payload);

      // Hide loader after API call completes
      if (loader === true) {
        this.props.Loader(false);
      }

      if (response.status === 200) {
        const responseData = response.data;
        if (responseData.code === 200) {
          const responseVariables = responseData.data?.variables || [];
          const currentPageConfig = this.state.pageConfig;
          const currentOutputVariables = this.state.outputVariables;
          
          if (responseVariables && responseVariables.length > 0 && resultVar && currentPageConfig) {
            // Map response variables using to_page_mapping
            const toPageMapping = currentPageConfig.to_page_mapping || [];
            const variableMapping = {};
            
            toPageMapping.forEach((toMap) => {
              if (toMap.field_mappings && Array.isArray(toMap.field_mappings)) {
                toMap.field_mappings.forEach((mField) => {
                  if (mField.automation_variable_id && mField.pages_variable_name) {
                    variableMapping[mField.automation_variable_id] = mField.pages_variable_name;
                  }
                });
              }
            });
            
            const responseVariableMap = {};
            responseVariables.forEach((responseVar) => {
              const pageVariableName = variableMapping[responseVar.id];
              if (pageVariableName) {
                responseVariableMap[pageVariableName] = responseVar;
              }
            });
            
            const resultVariable = responseVariableMap[resultVar];
            
            if (resultVariable) {
              let resRecordsData = [];
              try {
                const recordsData = isSet(resultVariable.value, resultVariable.selected_value);
                resRecordsData = IsJsonString(recordsData) ? JSON.parse(recordsData) : recordsData;
                
                if (!Array.isArray(resRecordsData)) {
                  resRecordsData = resRecordsData ? [resRecordsData] : [];
                }
                
                // Total records: from totalRecordVar in API response if configured, else current page length
                let totalRecords = resRecordsData.length;
                if (totalRecordVar) {
                  const totalRecordVariable = responseVariableMap[totalRecordVar];
                  if (totalRecordVariable) {
                    const totalVal = isSet(totalRecordVariable.value, totalRecordVariable.selected_value);
                    const num = parseInt(totalVal, 10);
                    if (!Number.isNaN(num) && num >= 0) totalRecords = num;
                  }
                }
                
                // Build table structure
                console.log('resultFields',resultFields);
                const tableHead = this.buildTableHead(resRecordsData, resultFields, recordIdField);
                const tableData = this.buildTableData(resRecordsData, tableHead, recordIdField);
                
                this.setState({
                  status: 200,
                  tableRecords: {
                    tableHead,
                    tableData: {
                      data: tableData,
                      status: 200
                    },
                    pagination: {
                      ...pagination,
                      totalRecords
                    }
                  }
                });
              } catch (error) {
                console.error('Error parsing records data:', error);
                this.setState({
                  status: 200,
                  tableRecords: {
                    tableData: { data: [], status: 400 },
                    tableHead: this.state.tableRecords.tableHead,
                    pagination: { ...pagination, totalRecords: 0 }
                  }
                });
              }
            }
          }
        }
      }
    } catch (error) {
      console.error('Modal records API error:', error);
      // Hide loader on error if it was shown
      if (loader === true) {
        this.props.Loader(false);
      }
      if (this.props.failMessage) {
        this.props.failMessage("Something went wrong...");
      }
    }
  }

  getSelectedId = (selectedValue) => {
    if (selectedValue == null) return selectedValue;
    const stored = getLookupStoredValue(selectedValue);
    return stored !== "" ? stored : selectedValue;
  };

  // Helper function to get nested property value using dot notation (e.g., "country.name")
  getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    const keys = path.split('.');
    let value = obj;
    for (const key of keys) {
      if (value === null || value === undefined) {
        return undefined;
      }
      value = value[key];
    }
    return value;
  };

  // Helper function to check if nested property exists
  hasNestedProperty = (obj, path) => {
    if (!obj || !path) return false;
    const keys = path.split('.');
    let current = obj;
    for (const key of keys) {
      if (current === null || current === undefined || !current.hasOwnProperty(key)) {
        return false;
      }
      current = current[key];
    }
    return true;
  };

  columnIsCheckbox = (records, field, key) => {
    if (isPagesLookupCheckboxType(field && (field.type || field.fieldType))) {
      return true;
    }
    if (!records || !key) return false;
    let seen = false;
    for (let i = 0; i < records.length; i += 1) {
      const value = String(key).indexOf(".") !== -1
        ? this.getNestedValue(records[i], key)
        : records[i][key];
      if (value === undefined || value === null || value === "") continue;
      if (!isPagesLookupCheckboxToken(value)) return false;
      seen = true;
    }
    return seen;
  };

  checkboxCellValue = (rawValue) => {
    const selectedValue = (rawValue === undefined || rawValue === null || rawValue === "")
      ? "false"
      : rawValue;
    return getSelectedValueBasedOnField({
      element: "CheckBoxes",
      selectedValue,
    });
  };

  // Build table head from records - if resultFields exist, use only those; otherwise use all fields
  buildTableHead = (records, resultFields, recordIdField) => {
    const tableHead = [
      {
        id: 'radio',
        type: "RadioButton",
        columnId: "",
        isShow: true,
        attributes: { style: { width: "30px" } }
      }
    ];

    if (!records || records.length === 0) {
      return tableHead;
    }

    const firstRecord = records[0];
    
    if (resultFields && resultFields.length > 0) {
      // Use only fields specified in Field tags (supports nested paths like "country.name")
      // Always add all fields from resultFields, even if they don't exist in the first record
      resultFields.forEach((field) => {
        const isCheckbox = this.columnIsCheckbox(records, field, field.key);
        tableHead.push({
          name: field.label || field.key,
          type: isCheckbox ? "Others" : "HyperLink",
          columnId: field.key,
          isShow: true,
          isCheckbox,
        });
      });
    } else {
      // Use all direct fields from the record (excluding nested objects)
      Object.keys(firstRecord).forEach((key) => {
        const value = firstRecord[key];
        if (value !== null && value !== undefined && 
            (typeof value !== 'object' || (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length < 10))) {
          const isCheckbox = this.columnIsCheckbox(records, null, key);
          tableHead.push({
            name: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
            type: isCheckbox ? "Others" : "HyperLink",
            columnId: key,
            isShow: true,
            isCheckbox,
          });
        }
      });
    }

    return tableHead;
  };

  // Build table data from records
  buildTableData = (records, tableHead, recordIdField) => {
    const tableData = [];
    const propSelectedId = this.getSelectedId(this.props.selectedValue);
    const currentSelected = (this.state.selectedValueCustom !== undefined && this.state.selectedValueCustom !== null && this.state.selectedValueCustom !== '')
      ? this.state.selectedValueCustom
      : propSelectedId;
    const selectedIdStr = currentSelected != null ? String(currentSelected) : null;

    this.lookupSource = {};
    const defaultField =
      (this.state.config && this.state.config.defaultField) || "";
    const firstDataColumnId = (
      tableHead.find((col) => col && col.columnId) || {}
    ).columnId;

    records.forEach((record) => {
      const recordId = getLookupRecordId(record, recordIdField);
      const metaRowId = getLookupRowId(record);
      if (!recordId) return;
      this.lookupSource[recordId] = record;
      if (metaRowId) {
        this.lookupSource[metaRowId] = record;
      }

      const isChecked = selectedIdStr !== null && recordId === selectedIdStr;

      const fieldsRow = {
        RadioButton: {
          checked: isChecked,
          name: 'windowCheckbox'
        }
      };

      // Match autocomplete: only defaultField (or first result column) is display label
      tableHead.forEach((column) => {
        if (column.columnId && column.columnId !== '') {
          // Get field value (supports both direct and nested paths)
          const fieldValue = column.columnId.includes('.')
            ? this.getNestedValue(record, column.columnId)
            : record[column.columnId];
          const colKey = String(column.columnId);
          const isDefaultDisplay = !column.isCheckbox && (defaultField
            ? colKey.toLowerCase() === String(defaultField).toLowerCase()
            : column.columnId === firstDataColumnId);

          fieldsRow[column.columnId] = {
            className: column.isCheckbox
              ? ""
              : (isDefaultDisplay
                ? "primary_color cursor-pointer"
                : "cursor-pointer"),
            isDefaultDisplay,
            value: column.isCheckbox
              ? this.checkboxCellValue(fieldValue)
              : (fieldValue !== undefined && fieldValue !== null ? String(fieldValue) : '')
          };
        }
      });

      tableData.push({
        clickHandler: this.onChangeSelectLookup.bind(this, recordId),
        className: isChecked ? 'selected' : '',
        rowId: recordId,
        metaRowId,
        data: fieldsRow
      });
    });

    return tableData;
  };


cancelLoopupModalHandler = () => {
  if (this.props.cancelLoopupModalHandler) {
    this.props.cancelLoopupModalHandler();
  }
}

    
    render () {
        const windowName = this.props.windowName || 'Record';
        const ModalTitle = "Select " + windowName;
        const modalType = 'tableList';
        const modalButtonList = [
            {
              attributes:{
                className:"btn btn-cancel",
                "data-dismiss":"modal",
                "id":"closeLookupModal",
              },
              clickHandler:this.cancelLoopupModalHandler,
              name:"Cancel"
            }
          ];
          const FooterButtonList = [
            {
              attributes:{
                className:"btn primary_bg cursor-pointer",
                "data-dismiss":"modal",
              },
              disabled:(this.state.selectedValueCustom!=='' && this.state.selectedValueCustom!==null)? false:true,
              clickHandler:this.confirmLoopupModalHandler,
              name:"Confirm"
            }
          ];
        try{
          return (
            <Wrp>
            <TableModal 
              isModalOpen={this.state.isModalOpen}
              title={ModalTitle}
              modalType={modalType}
              buttonList={modalButtonList}
              tableRecords={this.state.tableRecords}
              FooterButtonList={FooterButtonList}
              recordsChangeHandler={this.recordsChangeHandler}
              isConfirmPage={this.state.isConfirmPage}
               />
            </Wrp>
          )
        }catch(e){
          console.error('LookupModal render error:', e);
          if (this.props.failMessage) {
            this.props.failMessage("Something went wrong...");
          }
        }
        
    }
}

const mapDispatchToProps = dispatch => {
  return {
    Loader: (bool) => dispatch(actions.loader(bool)),
    succMessage: (msg) => dispatch(actions.succMessage(msg)),
    failMessage: (msg) => dispatch(actions.failMessage(msg)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(PagesLookupModal);